/* eslint-disable react/jsx-sort-props */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Box } from '@mui/joy';
import { observer } from 'mobx-react-lite';

import SiflyLogo from '../../assets/images/SiflyLogo.svg?react';
import { ViewMode } from '../../models/RtvUiState';
import { campaignRootStore } from '../../stores/CampaignRootStore';
import ContrastButton from '../ContrastButton';
import LiveUserMenu from './LiveUserMenu';
import VolumeControl from './VolumeControl';

type CampaignHeaderProps = {
  projectName: string;
  campaignName: string;
  campaignId: string;
  showUserControls?: boolean;
};

const CampaignHeader: React.FC<CampaignHeaderProps> = observer(
  ({ projectName, campaignName, campaignId, showUserControls = false }) => {
    const { t: translate } = useTranslation();
    const { rtvUiState } = campaignRootStore.rtvUiStore;

    return (
      <Box className='flex w-full h-12 items-center justify-start gap-6 px-3'>
        <SiflyLogo />
        <Box
          sx={{
            color: 'text.secondary'
          }}
        >
          {projectName}
          {` / ${campaignName}`}
        </Box>
        {rtvUiState?.viewMode === ViewMode.LIVE ? (
          <>
            <ContrastButton>{translate('campaign_view.live_activity')}</ContrastButton>
            <Box
              className='px-4 cursor-pointer'
              onClick={() =>
                campaignRootStore.rtvUiStore.updateRtvUiState({
                  viewMode: ViewMode.MAP
                })
              }
            >
              {translate('campaign_view.map')}
            </Box>
          </>
        ) : (
          <>
            <Box
              className='px-4 cursor-pointer'
              onClick={() =>
                campaignRootStore.rtvUiStore.updateRtvUiState({
                  viewMode: ViewMode.LIVE
                })
              }
            >
              {translate('campaign_view.live_activity')}
            </Box>
            <ContrastButton>{translate('campaign_view.map')}</ContrastButton>
          </>
        )}
        {showUserControls && (
          <Box className='flex items-center ml-auto gap-3'>
            <VolumeControl />
            <LiveUserMenu campaignId={campaignId} />
          </Box>
        )}
      </Box>
    );
  }
);

export default CampaignHeader;
